import moment from 'moment';
import { defineMessages, InjectedIntl } from 'react-intl';

export enum DurationStyle {
    Long = 'Long',
    Short = 'Short',
    Minimal = 'Minimal',
}

const messages = {
    [DurationStyle.Long]: defineMessages({
        hours: {
            id: 'formatMoment.duration.long.hours',
            description: 'Long format for hours component of the flight duration',
            defaultMessage: '{hours, number} {hours, plural, one {Hour} other {Hours}}'
        },
        minutes: {
            id: 'formatMoment.duration.long.minutes',
            description: 'Long format for minutes component of the flight duration',
            defaultMessage: '{minutes, number} {minutes, plural, one {Minute} other {Minutes}}'
        },
    }),
    [DurationStyle.Short]: defineMessages({
        hours: {
            id: 'formatMoment.duration.short.hours',
            description: 'Short format for hours component of the flight duration',
            defaultMessage: '{hours, number} {hours, plural, one {HR} other {HRS}}'
        },
        minutes: {
            id: 'formatMoment.duration.short.minutes',
            description: 'Short format for minutes component of the flight duration',
            defaultMessage: '{minutes, number} {minutes, plural, one {MIN} other {MINS}}'
        },
    }),
    [DurationStyle.Minimal]: defineMessages({
        hours: {
            id: 'formatMoment.duration.minimal.hours',
            description: 'Minimal format for hours component of the flight duration',
            defaultMessage: '{hours, number}h'
        },
        minutes: {
            id: 'formatMoment.duration.minimal.minutes',
            description: 'Minimal format for minutes component of the flight duration',
            defaultMessage: '{minutes, number}m'
        },
    })
};

export function formatDuration(
        intl: InjectedIntl,
        duration: moment.Duration | null,
        style: DurationStyle): string | null {
    if (duration) {
        const durationTotalMinutes = Math.round(duration.asMinutes());
        const durationHours = Math.floor(durationTotalMinutes / 60);
        const durationMinutes = durationTotalMinutes % 60;
        const parts = [];
        if (durationHours > 0) {
            parts.push(intl.formatMessage(messages[style].hours, {hours: durationHours}));
        }
        if (durationMinutes > 0) {
            parts.push(intl.formatMessage(messages[style].minutes, {minutes: durationMinutes}));
        }
        return parts.join(' ');
    } else {
        return null;
    }
}
